import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";

const CreateStaffComponent = loadable(
  () => import("../../components/Staff/CreateStaff")
);
const CreateStaff = () => {
  const { mutateAsync, isPostLoading  } = usePostHook({
    queryKey: ["staff"],
    navigateURL: "/staff",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.STAFF}`;
    let formData = {
      ...values,
      "mobile_number": `+977${values?.mobile_number}`,
      "secondary_contact":values?.secondary_contact? `+977${values?.secondary_contact}`: `+977${values?.mobile_number}`
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Staff</span>
      </div>
      <CreateStaffComponent
      isLoading={isPostLoading}
       handleCreate={handleCreate}
        />
    </>
  );
};

export default CreateStaff;
